import React from "react";

import Typography from "@mui/material/Typography";

import { formatCurrency, formatCurrencyFromCents } from "@app/utils/utils";

import LoadSpinner from "@rui/LoadSpinner";
import { Row } from "@rui/Stack";

interface CheckoutLineItemProps {
  isLoading?: boolean;
  label: React.ReactNode;
  testId?: string;
  unit?: "dollars" | "cents";
  value?: number;
  /** Value that will be shown if the value is 0. If none passed, will default to "$0.00" */
  zeroValue?: string;
}

const CheckoutLineItem = ({
  isLoading = false,
  label,
  testId,
  unit = "dollars",
  value,
  zeroValue,
}: CheckoutLineItemProps) => {
  const valueFormatter =
    unit === "cents" ? formatCurrencyFromCents : formatCurrency;

  return (
    <Row
      data-test-id={testId}
      variant="apart"
      spacing={1}
      sx={{
        width: "100%",
        color: value == null ? "transparent.white.60" : "#FFF",
      }}
    >
      {typeof label === "string" ? <Typography>{label}</Typography> : label}
      {isLoading ? (
        <LoadSpinner size={12} />
      ) : (
        <Typography>
          {value == null
            ? "Calculated in next step"
            : value < 0
              ? `(${valueFormatter(Math.abs(value))})`
              : value === 0 && zeroValue != null
                ? zeroValue
                : `${valueFormatter(value)}`}
        </Typography>
      )}
    </Row>
  );
};

export default CheckoutLineItem;
